'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".TrackPageTitle-module_container__1wM3w{height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;clip:rect(0,0,0,0);border:0;white-space:nowrap}";
var styles = {"container":"TrackPageTitle-module_container__1wM3w"};
styleInject["default"](css_248z, '69cc71c7-5504-4f8f-897b-d0834db71ade');

exports["default"] = styles;
